import {
    MovieStreamMetaFragment,
    SkippableFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

// typesafe filter
export function filterFragments(
    fragments: NonNullable<MovieStreamMetaFragment['skippableFragments']>
): SkippableFragment[] {
    return fragments.reduce<SkippableFragment[]>((acc, fragment) => {
        if (fragment) {
            acc.push(fragment);
        }
        return acc;
    }, []);
}
